<div>
    <!--Top of Page-->
    <div class="header">
        <h1 class="page-title">Full Order Details: {{general_info.get('lading_id')?.value}}</h1>
        <div id="lading_status_box">Status: {{general_info.get('lading_status')?.value}}
        </div>
        <div *ngIf="general_info.get('drop_trailer')?.value" id="drop-trailer-button">Drop Trailer Page</div>
        <input #dark_mode type="checkbox" [hidden]="true">
        <!--
            Jump to: <a [routerLink]="'/full-order-details/' + uuid" [fragment]="'financial_link'">Financial</a>
        -->
    </div>
    <div class="page-body">
        <div class="flex-row">
            <mat-card class="card left-card" style="max-width:50%">
                <mat-card-header>
                    <mat-card-title>Consolidations</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="consolidation_id == 0 && checked_for_consolidation">This lading is not part of a consolidation.</div>
                    <div style="display:flex; justify-content:space-between" *ngIf="consolidation_id != 0">
                        <div>Consolidation ID:</div>
                        <div>{{consolidation_id}}</div>
                    </div>
                    <div style="display:flex; justify-content:space-between" *ngIf="consolidation_id != 0">
                        <div>Is this order the parent order?</div>
                        <div>{{is_parent_lading ? "Yes" : "No"}}</div>
                    </div>
                    <div style="display:flex; justify-content:space-between" *ngIf="consolidation_id != 0">
                        <span>Other Orders in Consolidation:</span>
                        <span *ngIf="associated_ladings.length == 0">None</span>
                        <div *ngIf="associated_ladings.length > 0">
                            <div *ngFor="let lading of associated_ladings" style="text-align:right">
                                <a [href]="'/full-order-details/' + lading['uuid']" target="_blank">
                                    <span>{{lading['alternate_reference']}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <button mat-raised-button *ngIf="consolidation_id != 0 && checked_for_consolidation" (click)="addToConsol.show()" style="margin-right:10px">Add Order to Consolidation</button>
                    <button mat-raised-button *ngIf="(consolidation_id != 0 && associated_ladings.length > 1) || (consolidation_id != 0 && associated_ladings.length == 1 && is_parent_lading)" (click)="removeFromConsol.show()">Remove Order from Consolidation</button>
                    <button mat-raised-button *ngIf="consolidation_id == 0 && checked_for_consolidation" (click)="createConsol()">Create Consolidation</button>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="general-information" class="card left-card">
                <mat-card-header class="card-header">
                    <input #collapse_general type="checkbox" [hidden]="true">
                    <mat-card-title>
                        General Information
                        <span class="lading-type" *ngIf="general_info.get('hot')?.value" style="margin-left:0.25em">
                            <i style="font-size: 25px;" class="fa-solid fa-fire"></i>
                        </span>
                        <span class="lading-type" *ngIf="general_info.get('expedited')?.value" style="margin-left:0.25em">
                            <i style="font-size: 25px;" class="fa-solid fa-truck-fast"></i>
                        </span>
                        <span class="lading-type" *ngIf="general_info.get('drop_trailer')?.value" style="margin-left:0.25em">
                            <i style="font-size: 25px;" class="fa-solid fa-trailer"></i>
                        </span>
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!general_info.disabled" (click)="submitForm()">
                            <mat-icon>save</mat-icon>
                        </button>
                        <button matTooltip="Edit General Info" *ngIf="general_info.disabled" (click)="enableGeneralInfo()">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button matTooltip="Cancel Edit" *ngIf="!general_info.disabled" (click)="disableGeneralInfo()">
                            <i style="font-size: 22px;" class="fa-solid fa-xmark"></i>
                        </button>
                        <button [matTooltip]="collapse_general.checked ? 'View More' : 'View Less'"
                            (click)="collapse_general.checked = !collapse_general.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_general.checked, 'fa-solid fa-chevron-down': collapse_general.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_general.checked">
                    <div class="text-fields">
                        <form [formGroup]="general_info">
                            <mat-form-field>
                                <mat-label>Pro Bill</mat-label>
                                <input matInput formControlName="pro_bill" placeholder="Pro Bill">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>BOL Number</mat-label>
                                <input matInput formControlName="lading_number" placeholder="BOL Number">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Customer</mat-label>
                                <input matInput formControlName="customer_name" placeholder="Customer">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Shipper</mat-label>
                                <input matInput formControlName="shipper_name" placeholder="Shipper">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Consignee</mat-label>
                                <input matInput formControlName="consignee_name" placeholder="Consignee">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Carrier</mat-label>
                                <input matInput formControlName="carrier_name" placeholder="Carrier">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Alternate Reference</mat-label>
                                <input matInput formControlName="alternate_reference" placeholder="Alternate Reference">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Lading Status</mat-label>
                                <mat-select formControlName="lading_status" value="{{general_info.get('lading_status')?.value}}">
                                    <mat-option *ngFor="let status of getLadingStatuses(); let i = index" [value]="status">
                                        {{status}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Trip Number</mat-label>
                                <input matInput formControlName="trip_number" placeholder="Trip Number">
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>M-Week</mat-label>
                                <input matInput formControlName="week_no" placeholder="Week No">
                            </mat-form-field>                            
                        </form>
                    </div>
                    <app-purchase-order-editor [ladingUuid]="uuid"></app-purchase-order-editor>
                    <div class="checkboxes" >
                        <form [formGroup]="general_info" style="display:flex;flex-direction:column">
                            <mat-checkbox formControlName="hot">Hot</mat-checkbox>
                            <mat-checkbox formControlName="expedited">Expedited</mat-checkbox>
                            <mat-checkbox formControlName="drop_trailer">Drop Trailer</mat-checkbox>
                        </form>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="load-information" class="card right-card">
                <input #collapse_load type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Load Information
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!general_info.disabled" (click)="submitForm()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Load Info" *ngIf="general_info.disabled" (click)="enableGeneralInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Edit" *ngIf="!general_info.disabled" (click)="disableGeneralInfo()"><i style="font-size: 22px;" class="fa-solid fa-xmark"></i></button>
                        <button [matTooltip]="collapse_load.checked ? 'View More' : 'View Less'"
                            (click)="collapse_load.checked = !collapse_load.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_load.checked, 'fa-solid fa-chevron-down': collapse_load.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_load.checked">
                    <div class="text-fields" style="border-bottom:1px solid darkgrey">
                        <form [formGroup]="general_info">
                            <mat-form-field>
                                <mat-label>Load Details</mat-label>
                                <input matInput formControlName="load_details" placeholder="Load Details">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Pieces</mat-label>
                                <input matInput formControlName="load_pieces" placeholder="Pieces">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Equipment Type</mat-label>
                                <mat-select formControlName="type_of_equipment" value="{{general_info.get('type_of_equipment')?.value}}">
                                    <mat-option *ngFor="let type of getEquipmentTypes() | keyvalue" [value]="type.value">
                                        {{type.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Load Length</mat-label>
                                <input matInput formControlName="load_length" placeholder="Load Length">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Load Length Unit</mat-label>
                                <input matInput formControlName="load_length_unit" placeholder="Load Length Unit">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Pallets</mat-label>
                                <input matInput formControlName="load_pallets" placeholder="Pallets">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Load Weight</mat-label>
                                <input matInput formControlName="load_weight" placeholder="Load Weight">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Actual Load Weight</mat-label>
                                <input matInput formControlName="load_weight_actual" placeholder="Actual Load Weight">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Load Weight Unit</mat-label>
                                <input matInput formControlName="load_weight_unit" placeholder="Load Weight Unit">
                            </mat-form-field>
                        </form>
                    </div>
                    <div class="text-fields" [formGroup]="general_info">
                        <!-- mat-form-field width can be set with [style.width.%] or [style.width.px]-->
                        <mat-form-field>
                            <mat-label>Appointment Date</mat-label>
                            <input matInput formControlName="appointment_date" [matDatepicker]="apptDatePicker">
                            <mat-datepicker-toggle matIconSuffix [for]="apptDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #apptDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Appointment Start</mat-label>
                            <input matInput type="time" formControlName="appointment_start" type="time">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Appointment End</mat-label>
                            <input matInput type="time" formControlName="appointment_end">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Load Start Date</mat-label>
                            <input matInput formControlName="load_start_date" [matDatepicker]="startDatePicker">
                            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Load Start Time:</mat-label>
                            <input matInput type="time" formControlName="load_start_time">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Load End Date:</mat-label>
                            <input matInput formControlName="load_end_date" [matDatepicker]="endDatePicker">
                            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Load End Time:</mat-label>
                            <input matInput type="time" formControlName="load_end_time">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Load Special Info</mat-label>
                            <textarea matInput formControlName="load_special_info" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="4"></textarea>
                        </mat-form-field>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="shipper" class="card left-card">
                <input #collapse_shipper type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Shipper
                        <mat-button-toggle-group name="contact_type" #shipperContactGroup="matButtonToggleGroup">
                            <mat-button-toggle matTooltip="Shipper Contact" value="contact_shipper_info"
                                checked><mat-icon>book</mat-icon></mat-button-toggle>
                            <mat-button-toggle matTooltip="Additional Info"
                                value="contact_shipper_generate"><mat-icon>content_copy</mat-icon></mat-button-toggle>
                        </mat-button-toggle-group>
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Edit Contact" (click)="getShipperDetails()">
                            <mat-icon>person</mat-icon>
                        </button>
                        <button matTooltip="Switch Contact" (click)="changingShipper.show();">
                            <mat-icon>compare_arrows</mat-icon>
                        </button>
                        <button matTooltip="Print Shipper" (click)="printPdf()">
                            <mat-icon>print</mat-icon>
                        </button>
                        <button matTooltip="Email Shipper" (click)="promptEmail('shipper')">
                            <mat-icon>email</mat-icon>
                        </button>
    
                        <button matTooltip="Save Changes" *ngIf="!shipper_info.disabled" (click)="submitForm()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Shipper" *ngIf="shipper_info.disabled" (click)="enableShipperInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!shipper_info.disabled" (click)="disableShipperInfo()"><i style="font-size: 22px;" class="fa-solid fa-xmark"></i></button>
                        <button [matTooltip]="collapse_shipper.checked ? 'View More' : 'View Less'"
                            (click)="collapse_shipper.checked = !collapse_shipper.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_shipper.checked, 'fa-solid fa-chevron-down': collapse_shipper.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_shipper.checked">
                    
                    <div *ngIf="shipperContactGroup.value == 'contact_shipper_info'">
                        
                        <div class="contact-tab">
                            <div>
                                <h4>Shipper Contact Information</h4>
                                <mat-form-field>
                                    <div *ngIf="shipperAddress">
                                        <textarea disabled="true" matInput [value]="shipper_info_text" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"></textarea> 
                                    </div>
                                </mat-form-field>
                            </div>
                            <div [formGroup]="shipper_info" style="display:flex;flex-direction:column">
                                <h4>Pickup Reference Number</h4>
                                <mat-checkbox formControlName="pickup_reference_number_required">Required</mat-checkbox>
                                <mat-form-field>
                                    <mat-label>Pickup Number</mat-label>
                                    <input matInput [value]="uneditable_shipper_info.pickup_reference_number" type="text" disabled>
                                </mat-form-field>
                            </div>
                            <div [formGroup]="shipper_info">
                                <h4>Contacts</h4>
                                <div style="display:flex;flex-direction:column">
                                    <mat-form-field>
                                        <mat-label>Appointment - Name:</mat-label>
                                        <input matInput [value]="uneditable_shipper_info.appointment_contact_name"
                                            type="text" disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Appointment - Phone:</mat-label>
                                        <input matInput [value]="uneditable_shipper_info.appointment_contact_phone"
                                            type="text" disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Job Site - Name:</mat-label>
                                        <input matInput [value]="uneditable_shipper_info.job_site_contact_name" type="text"
                                            disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Job Site - Phone:</mat-label>
                                        <input matInput [value]="uneditable_shipper_info.job_site_contact_phone" type="text"
                                            disabled>
                                    </mat-form-field>                                        
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="shipperContactGroup.value == 'contact_shipper_generate'" class="checkbox-groups" [formGroup]="shipper_info">
                        <span class="checkbox-group" title="shipper site checks" [formGroup]="shipper_info" >
                            <h4 style="margin-left: 10px;">Site Checks</h4>
                            <mat-checkbox formControlName="appointment">Appointment Required</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="loading_dock">Loading Dock</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="pickup_tailgate">Pickup Tailgate</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="truck_space">Truck Space</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="shipping_bol_required">Shipping BOL Required</mat-checkbox>
                        </span>
                        <span class="checkbox-group" title="shipper site type" [formGroup]="shipper_info">
                            <h4 style="margin-left: 10px;">Site Type</h4>
                            <mat-checkbox class="form-item-full-width" formControlName="commercial">Commercial</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="residential">Residential</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="job_site">Job Site</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="unmanned_job_site">Unmanned Job Site</mat-checkbox>
                        </span>
                        <span class="checkbox-group" title="shipper notification requirements" [formGroup]="shipper_info">
                            <h4 [ngClass]="{'dark': dark_mode.checked}">Notification Requirements</h4>
                            <mat-checkbox class="form-item-full-width" formControlName="notification_at_pickup">At Pickup</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="notification_delayed_pickup">Delayed Pickup</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="notification_at_delivery">At Delivery</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="notification_delayed_delivery">Delayed Delivery</mat-checkbox>
                            <mat-checkbox class="form-item-full-width" formControlName="notification_assessorials_incured">Assessorials Incured</mat-checkbox>
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="consignee" class="card right-card">
                <input #collapse_consignee type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Consignee
                        <mat-button-toggle-group name="contact_type" #consigneeContactGroup="matButtonToggleGroup">
                            <mat-button-toggle matTooltip="Consignee Contact" value="contact_consignee_info"
                                checked><mat-icon>book</mat-icon></mat-button-toggle>
                            <mat-button-toggle matTooltip="Additional Info"
                                value="contact_consignee_generate"><mat-icon>content_copy</mat-icon></mat-button-toggle>
                        </mat-button-toggle-group>
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Edit Contact" (click)="getConsigneeDetails()">
                            <mat-icon>person</mat-icon>
                        </button>
                        <button matTooltip="Switch Contact" (click)="changingConsignee.show();">
                            <mat-icon>compare_arrows</mat-icon>
                        </button>
                        <button matTooltip="Print Consignee" (click)="printPdf()">
                            <mat-icon>print</mat-icon>
                        </button>
                        <button matTooltip="Email Consignee" (click)="promptEmail('consignee')">
                            <mat-icon>email</mat-icon>
                        </button>
    
                        <button matTooltip="Save Changes" *ngIf="!consignee_info.disabled" (click)="submitForm()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Consignee" *ngIf="consignee_info.disabled" (click)="enableConsigneeInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!consignee_info.disabled"
                            (click)="disableConsigneeInfo()" class="financial-button"><i style="font-size: 22px;"
                                class="fa-solid fa-xmark"></i></button>
                        <button [matTooltip]="collapse_consignee.checked ? 'View More' : 'View Less'"
                            (click)="collapse_consignee.checked = !collapse_consignee.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_consignee.checked, 'fa-solid fa-chevron-down': collapse_consignee.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_consignee.checked">
                    <div *ngIf="consigneeContactGroup.value == 'contact_consignee_info'">
                        <div class="contact-tab">
                            <div>
                                <h4>Consignee Contact Information</h4>
                                <mat-form-field>
                                    <div *ngIf="consigneeAddress">
                                        <textarea disabled="true" matInput [value]="consignee_info_text" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"></textarea> 
                                    </div>
                                </mat-form-field>
                            </div>
                            <div [formGroup]="consignee_info" style="display:flex;flex-direction:column">
                                <h4>Delivery Reference Number</h4>
                                    <mat-checkbox formControlName="delivery_reference_number_required">Required</mat-checkbox>
                                <mat-form-field>
                                    <mat-label>Delivery Number</mat-label>
                                    <input matInput [value]="uneditable_consignee_info.pickup_reference_number" type="text" disabled>
                                </mat-form-field>
                            </div>
                            <div [formGroup]="consignee_info">
                                <h4>Contacts</h4>
                                <div style="display:flex;flex-direction:column">
                                    <mat-form-field>
                                        <mat-label>Appointment - Name:</mat-label>
                                        <input matInput [value]="uneditable_consignee_info.appointment_contact_name"
                                            type="text" disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Appointment - Phone:</mat-label>
                                        <input matInput [value]="uneditable_consignee_info.appointment_contact_phone"
                                            type="text" disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Job Site - Name:</mat-label>
                                        <input matInput [value]="uneditable_consignee_info.job_site_contact_name" type="text"
                                            disabled>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Job Site - Phone:</mat-label>
                                        <input matInput [value]="uneditable_consignee_info.job_site_contact_phone" type="text"
                                            disabled>
                                    </mat-form-field>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div *ngIf="consigneeContactGroup.value == 'contact_consignee_generate'" [formGroup]="consignee_info" class='checkbox-groups'>
                        <div class="checkbox-group">
                            <h4>Site Checks</h4>
                            <mat-checkbox formControlName="appointment">Appointment</mat-checkbox>
                            <mat-checkbox formControlName="loading_dock">Loading Dock</mat-checkbox>
                            <mat-checkbox formControlName="pickup_tailgate">Pickup Tailgate</mat-checkbox>
                            <mat-checkbox formControlName="truck_space">Truck Space</mat-checkbox>
                            <mat-checkbox formControlName="call_site">Call Site</mat-checkbox>
                        </div>
                        <div class="checkbox-group">
                            <h4>Site Type</h4>
                            <mat-checkbox formControlName="commercial">Commercial</mat-checkbox>
                            <mat-checkbox formControlName="residential">Residential</mat-checkbox>
                            <mat-checkbox formControlName="job_site">Job Site</mat-checkbox>
                            <mat-checkbox formControlName="unmanned_job_site">Unmmanned Job Site</mat-checkbox>
                            <mat-checkbox formControlName="convention_center">Convention Center</mat-checkbox>
                            <mat-checkbox formControlName="pop_up_store">Pop-up Store</mat-checkbox>
                        </div>
                        <div class="checkbox-group">
                            <h4>Notification Requirements</h4>
                            <mat-checkbox formControlName="notification_at_pickup">At Pickup</mat-checkbox>
                            <mat-checkbox formControlName="notification_delayed_pickup">Delayed Pickup</mat-checkbox>
                            <mat-checkbox formControlName="notification_at_delivery">At Delivery</mat-checkbox>
                            <mat-checkbox formControlName="notification_delayed_delivery">Delayed Delivery</mat-checkbox>
                            <mat-checkbox formControlName="notification_assessorials_incured">Assessorials Incured</mat-checkbox>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="status-timeline" class="card left-card">
                <input #collapse_status_timeline type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Lading Status Timeline
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button [matTooltip]="collapse_status_timeline.checked ? 'View More' : 'View Less'"
                        (click)="collapse_status_timeline.checked = !collapse_status_timeline.checked">
                            <i style="font-size: 22px;"
                            [ngClass]="{'fa-solid fa-chevron-up': !collapse_status_timeline.checked, 'fa-solid fa-chevron-down': collapse_status_timeline.checked}"
                            class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_status_timeline.checked">
                    <div *ngFor="let status of this.status_form_set; let i = index" style="width:100%">
                        <div id="status">
                            <form [formGroup]="status"
                                style="display:flex;flex:1;border:1px solid black;margin:0.2em;padding:0.3em;border-radius:3px">
                                <div style="flex:2;">
                                    <select formControlName="status" id="lading-status">
                                        <option *ngFor="let status_option of STATUSES" [value]="status_option">
                                            {{status_option}}</option>
                                    </select>
                                </div>
                                <div style="flex:2">
                                    <input type="date" formControlName="date_created" style="margin-right:2px;border:1px solid grey">
                                    <input type="time" formControlName="time_created" style="border:1px solid grey">
                                </div>
                                <div style="flex:1;justify-content:flex-end;display:flex">
                                    <button *ngIf="!status.get('status')?.disabled"
                                        (click)="cancelStatusChange(i)">Cancel</button>
                                    <button (click)="toggleStatusEdit(i)">{{status.get('status')?.disabled ? 'Edit' :
                                        'Save'}}</button>
                                    <button (click)="deleteStatus(i)">Delete</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="documents" class="card right-card">
                <div class="dropzone-wrapper"
                     (dragover)="handleDocumentDragOver($event)"
                     (dragleave)="handleDocumentDragLeave($event)"
                     (drop)="handleDocumentDrop($event)">
              
                  <input #collapse_documents type="checkbox" [hidden]="true">
                  
                  <mat-card-header class="card-header">
                    <mat-card-title>
                      Documents
                    </mat-card-title>
                    <div class="card-header-btns">
                      <button [matTooltip]="collapse_documents.checked ? 'View More' : 'View Less'"
                              (click)="collapse_documents.checked = !collapse_documents.checked"
                              class="financial-button">
                        <i style="font-size: 22px;"
                           [ngClass]="{
                             'fa-solid fa-chevron-up': !collapse_documents.checked,
                             'fa-solid fa-chevron-down': collapse_documents.checked
                           }"
                           class="fa"></i>
                      </button>
                    </div>
                  </mat-card-header>
              
                  <mat-card-content *ngIf="!collapse_documents.checked">
                    <mat-list role="list" *ngFor="let doc of documentList; index as i;" [ngClass]="{'dark': dark_mode.checked}">
                      <mat-list-item style="border-bottom:1px solid black;border-radius:0">
                        <span style="display:inline-block;width:30%;color:#4d4dfa">
                          {{ doc.file_description ? doc.file_description : 'Unknown File Type' }}
                        </span>
                        <span style="display:inline-block;width:58%">{{ doc.file_name }}</span>
                        <span style="display:inline-block;width:10%">
                          <button (click)="openModal(documentList[i])">
                            {{ doc.file_format === 'tif' ? 'Download' : 'View' }}
                          </button>
                        </span>
                      </mat-list-item>
                    </mat-list>
                  </mat-card-content>
              
                  <div *ngIf="isDraggingOverDocument" class="dropzone-overlay">
                    Drop files here to upload
                  </div>
              
                </div>
              </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="customer" class="card left-card">
                <input #collapse_customer type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Customer
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!customer_info.disabled" (click)="submitForm()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Customer" *ngIf="customer_info.disabled" (click)="enableCustomerInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!customer_info.disabled" (click)="disableCustomerInfo()"><i style="font-size: 22px;" class="fa-solid fa-xmark"></i></button>
                        <button [matTooltip]="collapse_customer.checked ? 'View More' : 'View Less'"
                            (click)="collapse_customer.checked = !collapse_customer.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_customer.checked, 'fa-solid fa-chevron-down': collapse_customer.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_customer.checked">
                    <div class="checkbox-groups" [formGroup]="customer_info">
                        <div class="checkbox-group">
                            <h4>Document Requirements</h4>
                            <mat-checkbox formControlName="bol_required">BOL</mat-checkbox>
                            <mat-checkbox formControlName="invoice_bol_required">Invoice BOL</mat-checkbox>
                            <mat-checkbox formControlName="rate_quote_required">Rate Quote</mat-checkbox>
                            <mat-checkbox formControlName="invoice_po_required">Invoice PO</mat-checkbox>
                            <mat-form-field>
                                <mat-label>Invoice PO#:</mat-label>
                                <input matInput formControlName="invoice_po" type="text">
                            </mat-form-field>
                        </div>
                        <div class="checkbox-group">
                            <h4>Notification Requirements</h4>
                            <mat-checkbox formControlName="notification_at_pickup">At Pickup</mat-checkbox>
                            <mat-checkbox formControlName="notification_delayed_pickup">Delayed Pickup</mat-checkbox>
                            <mat-checkbox formControlName="notification_at_delivery">At Delivery</mat-checkbox>
                            <mat-checkbox formControlName="notification_delayed_delivery">Delayed Delivery</mat-checkbox>
                            <mat-checkbox formControlName="notification_assessorials_incured">Assessorials Incured</mat-checkbox>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="carrier" class="card right-card">
                <input #collapse_carrier type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Carrier
                        <mat-button-toggle-group name="contact_type" #contactGroup="matButtonToggleGroup">
                            <mat-button-toggle value="contact_info" matTooltip="Carrier Contact"
                                checked><mat-icon>book</mat-icon></mat-button-toggle>
                            <mat-button-toggle matTooltip="Additional Info"
                                value="contact_generate"><mat-icon>content_copy</mat-icon></mat-button-toggle>
                        </mat-button-toggle-group>
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Edit Contact" (click)="getCarrierDetails()">
                            <mat-icon>person</mat-icon>
                        </button>
                        <button matTooltip="Switch Contact" (click)="changingCarrier.show();">
                            <mat-icon>compare_arrows</mat-icon>
                        </button>
                        <button matTooltip="Print Carrier" (click)="printPdf()">
                            <mat-icon>print</mat-icon>
                        </button>
                        <button matTooltip="Email Carrier" (click)="promptEmail('carrier')">
                            <mat-icon>email</mat-icon>
                        </button>
                        <button [matTooltip]="collapse_carrier.checked ? 'View More' : 'View Less'"
                            (click)="collapse_carrier.checked = !collapse_carrier.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_carrier.checked, 'fa-solid fa-chevron-down': collapse_carrier.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_carrier.checked">
                    <div *ngIf="contactGroup.value == 'contact_info'"  class="text-fields">
                        <form [formGroup]="carrier_info">
                            <mat-form-field>
                                <mat-label>Organization</mat-label>
                                <input matInput formControlName="organization" placeholder="Carrier">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" placeholder="Name">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>Street Address</mat-label>
                                    <input matInput formControlName="street_address" placeholder="Street Address">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>Street Address Extended</mat-label>
                                    <input matInput formControlName="street_address_extended"
                                        placeholder="Street Address Extended">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>City</mat-label>
                                    <input matInput formControlName="city" placeholder="City">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>Postal Code</mat-label>
                                    <input matInput formControlName="postal_code" placeholder="Postal Code">
                            </mat-form-field>
                            <mat-form-field>
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="country" placeholder="Country">
                            </mat-form-field>
                        </form>
                        <form [formGroup]="general_info">
                            <mat-form-field>
                                <mat-label>Carrier Trailer</mat-label>
                                <input matInput formControlName="carrier_trailer">
                            </mat-form-field>
                        </form>
                    </div>
                    <div *ngIf="contactGroup.value !== 'contact_info'" [formGroup]="carrier_info" style="margin:20px">
                        <p>Green indicates a document with that type has already been uploaded.</p>
                        <mat-form-field style="display: block;">
                            <mat-label>Document Category</mat-label>
                            <mat-select formControlName="document_category">
                                <mat-option *ngFor="let category of getCategory()" [value]="category">
                                    {{category}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field style="display: block;"
                            *ngIf="this.carrier_info.get('document_category')?.value.length > 0">
                            <mat-label>Document Types Needed</mat-label>
                            <mat-select formControlName="document_type">
                                <mat-option
                                    *ngFor="let type of getCategoryType(this.carrier_info.get('document_category')?.value)"
                                    [value]="type">
                                    {{type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button color="primary">Generate Notification</button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="items" class="card left-card">
                <input #collapse_items type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Items
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button [matTooltip]="collapse_items.checked ? 'View More' : 'View Less'"
                        (click)="collapse_items.checked = !collapse_items.checked">
                        <i style="font-size: 22px;"
                            [ngClass]="{'fa-solid fa-chevron-up': !collapse_items.checked, 'fa-solid fa-chevron-down': collapse_items.checked}"
                            class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_items.checked">
                    <div class="items-list">
                        <span *ngFor="let item of packageArray; let i = index">
                            <span style="font-size: 20px;">
                                <strong>Package {{i + 1}} ({{item['products'].length}} products)</strong>
                            </span>
                            <br><br>
                            <div style="display: flex; justify-content: space-between;">
                                <span style="font-size: 20px;"><strong>{{item['delivered'] ? 'Delivered' : 'Not Delivered'}}</strong><br><br>
                                    <button (click)="collapse_items.checked = !collapse_items.checked"
                                        class="financial-button">
                                        <i style="font-size: 22px;"
                                            [ngClass]="{'fas fa-truck-loading': !collapse_items.checked, 'fas fa-times-circle': collapse_items.checked}"
                                            class="fa"></i>
                                    </button>
                                    <button class="financial-button">
                                        <i style="font-size: 22px;" class='fas fa-boxes'></i>
                                    </button>
                                </span>
                                <span style="font-size: 15px;">
                                    <p>Type: {{item['packaging_type']}}</p>
                                    <p>Length: {{item['length']}}</p>
                                    <p>Width: {{item['width']}}</p>
                                    <p>Height: {{item['height']}}</p>
                                    <p>Weight: {{item['weight']}}</p>
                                </span>
                            </div>
                        </span>
                        <span style="width:100%" *ngIf="packageArray.length == 0">
                            No products to display
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="products" class="card right-card">
                <input #collapse_products type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Products
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button mat-button (click)="exportCsv()">
                            Export CSV
                        </button>
                        <button [matTooltip]="collapse_products.checked ? 'View More' : 'View Less'"
                            (click)="collapse_products.checked = !collapse_products.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_products.checked, 'fa-solid fa-chevron-down': collapse_products.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_products.checked">
                    <ag-grid-angular style="width: 100%" class="ag-theme-alpine" [columnDefs]="productsColumnDefs"
                    [defaultColDef]="productsDefaultColDefs" [animateRows]="true" [rowData]="productsList"
                    domLayout="autoHeight" (gridReady)="onProductsGridReady($event)">
                    </ag-grid-angular>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="operations" class="card left-card">
                <input #collapse_operations type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>Operations</mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!operation_info.disabled" (click)="submitOperationInfo()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Operations" *ngIf="operation_info.disabled" (click)="enableOperationInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!operation_info.disabled"
                            (click)="disableOperationInfo()"><i style="font-size: 22px;"
                                class="fa-solid fa-xmark"></i></button>
                        <button [matTooltip]="collapse_operations.checked ? 'View More' : 'View Less'"
                            (click)="collapse_operations.checked = !collapse_operations.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_operations.checked, 'fa-solid fa-chevron-down': collapse_operations.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_operations.checked">
                    <div class="checkbox-groups" [formGroup]="operation_info">
                        <div class="checkbox-group">
                            <mat-checkbox formControlName="carrier_rated" (change)="onChangeCheckBox($event,'carrier_rated')">
                                Carrier Rated
                            </mat-checkbox>
                            <mat-checkbox formControlName="carrier_rerated" (change)="onChangeCheckBox($event,'carrier_rerated')">
                                Carrier Rerated
                            </mat-checkbox>
                            <mat-checkbox formControlName="straps_bars" (change)="onChangeCheckBox($event,'straps_bars')">
                                Straps and Bars
                            </mat-checkbox>
                            <mat-checkbox formControlName="lift_lull" (change)="onChangeCheckBox($event, 'lift_lull')">
                                Forklift or Lull
                            </mat-checkbox>
                        </div>
                        <div class="checkbox-group">
                            <mat-checkbox formControlName="call_site" (change)="onChangeCheckBox($event,'call_site')">
                                Call Site
                            </mat-checkbox>
                            <mat-checkbox formControlName="protective_equipment" (change)="onChangeCheckBox($event,'protective_equipment')">
                                Protective Equipment
                            </mat-checkbox>
                            <mat-checkbox formControlName="unmanned_job_site" (change)="onChangeCheckBox($event,'unmanned_job_site')">
                                Unmanned Job Site
                            </mat-checkbox>
                            <mat-form-field floatLabel="always">
                                <mat-label>Operation Notation:</mat-label>
                                <input matInput formControlName="operations_notation" type="text">
                            </mat-form-field>
                            <input matInput formControlName="lading_operation_uuid" type="text" hidden="true">
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="customer-care" class="card right-card">
                <input #collapse_customer_care type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>Customer Care</mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!customer_care_info.disabled"
                            (click)="submitCustomerCareInfo()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Customer Care" *ngIf="customer_care_info.disabled"
                            (click)="enableCustomerCareInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!customer_care_info.disabled"
                            (click)="disableCustomerCareInfo()"><i style="font-size: 22px;"
                                class="fa-solid fa-xmark"></i></button>
    
                        <button [matTooltip]="collapse_customer_care.checked ? 'View More' : 'View Less'"
                            (click)="collapse_customer_care.checked = !collapse_customer_care.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_customer_care.checked, 'fa-solid fa-chevron-down': collapse_customer_care.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_customer_care.checked">
                    <div class="checkbox-group" [formGroup]="customer_care_info">
                        <mat-checkbox formControlName="confirm_pick_up" (change)="onChangeCareCheckBox($event, 'confirm_pick_up')">
                            Confirm Pickup
                        </mat-checkbox>
                        <mat-checkbox formControlName="confirm_delivery" (change)="onChangeCareCheckBox($event, 'confirm_delivery')">
                            Confirm Delivery
                        </mat-checkbox>
                        <mat-checkbox formControlName="pod_required" (change)="onChangeCareCheckBox($event, 'pod_required')">
                            POD Required</mat-checkbox>
                        <mat-checkbox formControlName="purchase_order_required" (change)="onChangeCareCheckBox($event, 'purchase_order_required')">
                            Purchase Order Required</mat-checkbox>
                        <mat-form-field floatLabel="always">
                            <mat-label>Care Notation:</mat-label>
                            <input matInput formControlName="care_notation" type="text">
                        </mat-form-field>
                        <input matInput formControlName="lading_care_uuid" type="text" hidden="true">
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-row">
            <mat-card id="admin" class="card left-card">
                <input #collapse_administration type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>Administration</mat-card-title>
                    <div style="display: flex; justify-content: space-around; width: 100%; flex-basis: 30%;"
                    id="order-tags">
                        <mat-button-toggle-group name="administration_type" #administrationGroup="matButtonToggleGroup">
                            <mat-button-toggle value="dock_check" checked><fa-icon [icon]="dockCheckIcon"
                                    style="font-size: 22px;"></fa-icon>Dock Check</mat-button-toggle>
                            <mat-button-toggle value="invoicing"><fa-icon [icon]="invoicingIcon"
                                    style="font-size: 22px;"></fa-icon>Invoicing</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" *ngIf="!administration_info.disabled"
                            (click)="submitAdministrationInfo()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Administration" *ngIf="administration_info.disabled"
                            (click)="enableAdministrationInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!administration_info.disabled"
                            (click)="disableAdministrationInfo()"><i style="font-size: 22px;"
                                class="fa-solid fa-xmark"></i></button>

                        <button [matTooltip]="collapse_administration.checked ? 'View More' : 'View Less'"
                            (click)="collapse_administration.checked = !collapse_administration.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_administration.checked, 'fa-solid fa-chevron-down': collapse_administration.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_administration.checked">
                    <div *ngIf="administrationGroup.value == 'dock_check'" [formGroup]="administration_info" style="display:flex;flex-direction:column">
                        <mat-checkbox formControlName="po_audited"
                            (change)="onChangeAdministrationCheckBox($event,'po_audited')">PO Audited</mat-checkbox>
                        <mat-checkbox  formControlName="pod_audited"
                            (change)="onChangeAdministrationCheckBox($event,'pod_audited')">
                            POD Audited
                            </mat-checkbox>
                        <mat-checkbox  formControlName="confirm_charges"
                            (change)="onChangeAdministrationCheckBox($event,'confirm_charges')">
                            Confirm Charges
                        </mat-checkbox>
                        <mat-checkbox formControlName="carrier_invoiced" (change)="onChangeAdministrationCheckBox($event, 'carrier_invoiced')">
                            Carrier Invoiced
                        </mat-checkbox>
                        <mat-checkbox formControlName="freight_cost_approved" (change)="onChangeAdministrationCheckBox($event,'freight_cost_approved')">
                            Freight Cost Approved
                            </mat-checkbox>
                        <mat-checkbox formControlName="freight_cost_exception"
                            (change)="onChangeAdministrationCheckBox($event,'freight_cost_exception')">
                            Freight Cost Exception
                        </mat-checkbox>
                        <mat-checkbox formControlName="ready_invoice"
                            (change)="onChangeAdministrationCheckBox($event,'ready_invoice')">
                            Ready Invoice
                        </mat-checkbox>
                        <mat-checkbox formControlName="damage_claim"
                            (change)="onChangeAdministrationCheckBox($event,'damage_claim')">
                            Damage Claim
                        </mat-checkbox>
                        <mat-checkbox formControlName="intent_claim"
                            (change)="onChangeAdministrationCheckBox($event,'intent_claim')">
                            Intent Claim
                        </mat-checkbox>
                        <mat-checkbox formControlName="claim_review"
                            (change)="onChangeAdministrationCheckBox($event,'claim_review')">
                            Claim Review
                            </mat-checkbox>
                        <mat-checkbox formControlName="invoice_thanks"
                            (change)="onChangeAdministrationCheckBox($event,'invoice_thanks')">
                            Invoice Thanks
                            </mat-checkbox>
                        <mat-checkbox formControlName="invoice_due"
                            (change)="onChangeAdministrationCheckBox($event,'invoice_due')">
                            Invoice Due
                            </mat-checkbox>
                        <input matInput formControlName="lading_administration_uuid" type="text" hidden="true">
                    </div>
                    <div *ngIf="administrationGroup.value !== 'dock_check'" [formGroup]="administration_info">
                        <div style="display:flex;flex-direction:column">
                            <mat-checkbox formControlName="invoice_correct"
                            (change)="onChangeAdministrationCheckBox($event,'invoice_correct')">
                                Invoice Correct
                            </mat-checkbox>
                            <mat-checkbox formControlName="invoice_late"
                            (change)="onChangeAdministrationCheckBox($event,'invoice_late')">
                                Invoice Late
                            </mat-checkbox>
                            <mat-checkbox formControlName="carrier_invoice_exported"
                            (change)="onChangeAdministrationCheckBox($event,'carrier_invoice_exported')">
                                Carrier Invoice Exported
                            </mat-checkbox>
                            <mat-checkbox formControlName="customer_invoice_exported"
                            (change)="onChangeAdministrationCheckBox($event,'customer_invoice_exported')">
                                Customer Invoice Exported
                            </mat-checkbox>
                        </div>
                        <div class="text-fields">
                            <mat-form-field floatLabel="always">
                                <mat-label>Customer Invoice Date:</mat-label>
                                <input matInput formControlName="customer_invoice_date" type="date">
                            </mat-form-field>
                            <mat-form-field floatLabel="always">
                                <mat-label>Freight Cost Notation:</mat-label>
                                <input matInput formControlName="freight_cost_notation" type="text">
                            </mat-form-field>
                            <mat-form-field floatLabel="always">
                                <mat-label>Versapay Payment Reference:</mat-label>
                                <input matInput formControlName="versapay_payment_reference" type="text">
                            </mat-form-field>
                            <mat-form-field floatLabel="always">
                                <mat-label>Administration Notation:</mat-label>
                                <input matInput formControlName="administration_notation" type="text">
                            </mat-form-field>
                            <mat-form-field floatLabel="always">
                                <mat-label>Special Invoice:</mat-label>
                                <input matInput formControlName="special_invoice" type="text">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card id="sales-mgmt" class="card right-card">
                <input #collapse_sales type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>Sales/Management</mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Save Changes" matTooltip="Save Changes" *ngIf="!sales_info.disabled"
                            (click)="submitSalesInfo()"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Sales/Management" matTooltip="Save Changes" *ngIf="sales_info.disabled"
                            (click)="enableSalesInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!sales_info.disabled" (click)="disableSalesInfo()"><i style="font-size: 22px;" class="fa-solid fa-xmark"></i></button>
    
    
                        <button [matTooltip]="collapse_sales.checked ? 'View More' : 'View Less'"
                            (click)="collapse_sales.checked = !collapse_sales.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_sales.checked, 'fa-solid fa-chevron-down': collapse_sales.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content [formGroup]="sales_info" *ngIf="!collapse_sales.checked">
                    <div style="display:flex;flex-direction:column">
                        <mat-checkbox formControlName="quote_required"
                            (change)="onChangeSalesCheckBox($event, 'quote_required')">Quote Required</mat-checkbox>
                        <mat-checkbox formControlName="requote_required"
                            (change)="onChangeSalesCheckBox($event, 'requote_required')">Requote Required</mat-checkbox>
                        <mat-checkbox formControlName="customer_rated"
                            (change)="onChangeSalesCheckBox($event, 'customer_rated')">Customer Rated</mat-checkbox>
                    </div>
                    <div class="text-fields">
                        <mat-form-field>
                            <mat-label>Sales Notation:</mat-label>
                            <input matInput formControlName="sales_notation" type="text">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Management Notation:</mat-label>
                            <input matInput formControlName="management_notation" type="text">
                        </mat-form-field>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <app-financial-grid></app-financial-grid>
        <!-- <div class="flex-row">
            <mat-card id="financial" class="card">
                <a id="financial_link"></a>
                <input #collapse_financial type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Financial
                    </mat-card-title>
                    <div style="flex-basis: 20%; justify-content: flex-end; display: flex;">
                        <button 
                            mat-button
                            (click)="isFinancialGridEditToggled ? disableFinancialEditing() : enableFinancialEditing()"
                            class="service-charge-button">
                            <ng-container *ngIf="isFinancialGridEditToggled; else disableIcon">
                                <i class="fa-solid fa-floppy-disk"></i> SAVE CHANGES
                            </ng-container>
                            <ng-template #disableIcon>
                                <i class="fa-regular fa-floppy-disk"></i> EDIT
                            </ng-template>
                        </button>
                        <button 
                            mat-button (click)="openFinancialModal()" class="service-charge-button">ADD
                            SERVICE CHARGE
                        </button>
                        <button
                            mat-button (click)="openRemoveServiceModal()" class="service-charge-button">REMOVE
                            SERVICE CHARGE
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content style="max-height:fit-content; margin-left: 1em; margin-right: 1em" *ngIf="!collapse_financial.checked">
                    <div *ngIf="!showFinancialInfo" class="loading-spinner">
                        <mat-spinner></mat-spinner>
                    </div>
    
                    <ng-container *ngIf="showFinancialInfo">
                        <ag-grid-angular style="width: 100%" class="ag-theme-alpine" [columnDefs]="financialColumnDefs"
                            [defaultColDef]="defaultColDef" [animateRows]="true" [rowData]="financialRowData"
                            domLayout="autoHeight" (cellEditingStopped)="onCellEditingStopped($event)">
                        </ag-grid-angular>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div> -->
        <!-- <div class="flex-row">
            <mat-card id="wew" class="card">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Test
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content style="max-height:fit-content; margin-left: 1em; margin-right: 1em">
                    <app-financial-currency-editor></app-financial-currency-editor>
                </mat-card-content>
            </mat-card>
        </div> -->
        <div class="flex-row">
            <mat-card id="claims" class="card left-card">
                <input #collapse_claims type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Claims
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button matTooltip="Add Claims" (click)="claimsDialogBox.show()"><mat-icon>add</mat-icon></button>
                        <button matTooltip="Save Changes" *ngIf="!customer_care_info.disabled"><mat-icon>save</mat-icon></button>
                        <button matTooltip="Edit Claims" *ngIf="customer_care_info.disabled"
                            (click)="enableCustomerCareInfo()"><mat-icon>edit</mat-icon></button>
                        <button matTooltip="Cancel Changes" *ngIf="!customer_care_info.disabled"
                            (click)="disableCustomerCareInfo()"><i style="font-size: 22px;"
                                class="fa-solid fa-xmark"></i></button>
    
                        <button [matTooltip]="collapse_claims.checked ? 'View More' : 'View Less'"
                            (click)="collapse_claims.checked = !collapse_claims.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_claims.checked, 'fa-solid fa-chevron-down': collapse_claims.checked}"
                                class="fa">
                            </i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_claims.checked">
                    <br><br><br>
                </mat-card-content>
            </mat-card>
            <mat-card id="signatures" class="card right-card">
                <input #collapse_other type="checkbox" [hidden]="true">
                <mat-card-header class="card-header">
                    <mat-card-title>
                        Other
                    </mat-card-title>
                    <div class="card-header-btns">
                        <button [matTooltip]="collapse_other.checked ? 'View More' : 'View Less'"
                        (click)="collapse_other.checked = !collapse_other.checked">
                            <i style="font-size: 22px;"
                                [ngClass]="{'fa-solid fa-chevron-up': !collapse_other.checked, 'fa-solid fa-chevron-down': collapse_other.checked}"
                                class="fa"></i>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!collapse_other.checked">
                    <div>
                        <div style="width:100%">
                            <mat-list role="list" *ngFor="let signature of signatureList; let i = index">
                                <mat-list-item role="listitem" style="height: auto;border-bottom:1px solid darkgrey;padding-bottom:0.25em">
                                    {{signature.signatory}} - {{signature.task_type}}<br>
                                    <button (click)="viewSignature(signature)" style="margin-top:0.5em">View</button>
                                </mat-list-item>
                            </mat-list>
                        </div>
                        <button (click)="signatureDialog.show()">Add Signature</button>
                    </div>
                    <dialog #signatureDialog width="60vw" height="60vh">
                        <app-signature-pad #signaturePad></app-signature-pad>
                        <button (click)="addSignature()">Save</button>
                        <button (click)="signatureDialog.close()">Close</button>
                    </dialog>
                </mat-card-content>
            </mat-card>
        </div>
        <dialog style="background-color: white;width: 30%;height: auto;" #changingCarrier>
            <form [formGroup]="new_carrier_info" style="padding: 20px;">
                <h1>Select New Carrier</h1>
                <h3>Carrier</h3>
                <mat-form-field style="width: 100%;">
                    <input matInput placeholder="Start typing carrier name.." [matAutocomplete]="auto1"
                        formControlName="carrier_contact_control">
                    <mat-autocomplete #auto1="matAutocomplete">
                        <mat-option *ngFor="let item of filteredCarrierList | async" [value]="item">
                            <span>{{ item }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <h3>Carrier Address</h3>
                <mat-select [(value)]="carrierAddresses[0]">
                    <mat-option *ngFor="let type of carrierAddresses" [value]="type">
                        {{type}}
                    </mat-option>
                </mat-select>
                <input type="hidden" formControlName="carrier_address_uuid">
                <input type="hidden" formControlName="carrier_contact_uuid">
                <input type="hidden" formControlName="old_carrier_task_uuid">
                <br>
                <button style="margin-top: 10px;" (click)="changingCarrier.close();" mat-button>Close</button>
                <button style="margin-top: 10px;" (click)="submitNewCarrierInfo()" mat-button>Save</button>
            </form>

        </dialog>

        <dialog style="background-color: white;width: 30%;
        height: auto;" #changingShipper>
            <form [formGroup]="new_shipper_info" style="padding: 20px;">
                <h1>Select New Shipper</h1>
                <h3>Shipper</h3>
                <mat-form-field style="width: 100%;">
                    <input matInput placeholder="Start typing shipper name.." [matAutocomplete]="auto2"
                        formControlName="new_shipper_control">
                    <mat-autocomplete #auto2="matAutocomplete">
                        <mat-option *ngFor="let item of filteredShipperList | async" [value]="item">
                            <span>{{ item }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <h3>Shipper Address</h3>
                <mat-select [value]="shipperAddresses[0]">
                    <mat-option *ngFor="let type of shipperAddresses" [value]="type">
                        {{type}}
                    </mat-option>
                </mat-select>
                <input type="hidden" formControlName="shipper_address_uuid">
                <input type="hidden" formControlName="shipper_contact_uuid">
                <input type="hidden" formControlName="old_shipper_task_uuid">
                <br>
                <button style="margin-top: 10px;" (click)="changingShipper.close()" mat-button>Close</button>
                <button style="margin-top: 10px;" (click)="submitNewShipperInfo()" mat-button>Save</button>
            </form>
        </dialog>

        <dialog style="background-color: white;width: 30%;
        height: auto;" #changingConsignee>
            <form [formGroup]="new_consignee_info" style="padding: 20px;">
                <h1>Select New Consignee</h1>
                <h3>Consignee</h3>
                <mat-form-field style="width: 100%;">
                    <input matInput placeholder="Start typing consignee name.." [matAutocomplete]="auto3"
                        formControlName="new_consignee_control">
                    <mat-autocomplete #auto3="matAutocomplete">
                        <mat-option *ngFor="let item of filteredConsigneeList | async" [value]="item">
                            <span>{{ item }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <h3>Consignee Address</h3>
                <mat-select [value]="consigneeAddresses[0]">
                    <mat-option *ngFor="let type of consigneeAddresses" [value]="type">
                        {{type}}
                    </mat-option>
                </mat-select>
                <input type="hidden" formControlName="consignee_address_uuid">
                <input type="hidden" formControlName="consignee_contact_uuid">
                <input type="hidden" formControlName="old_consignee_task_uuid">
                <br>
                <button style="margin-top: 10px;" (click)="changingConsignee.close()" mat-button>Close</button>
                <button style="margin-top: 10px;" (click)="submitNewConsigneeInfo()" mat-button>Save</button>
            </form>
        </dialog>

        <dialog style="width: 30%; background-color: white; height: auto;" #serviceChargeDialog>
            <mat-card>
                <mat-card-header>
                    <h1>Add Service Charge</h1>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="service_charge_info">
                        <div formArrayName="service_list">
                            <div *ngFor="let sub_servicee_form of service_list.controls; let i = index;">
                                <mat-card-subtitle>Service Charge {{i + 1}}</mat-card-subtitle>
                                <div [formGroupName]="i" style="display: flex; justify-content: flex-start; gap: 10px;">
                                    <mat-form-field style="flex-basis: 40%;">
                                        <mat-select formControlName="services">
                                            <mat-option *ngFor="let service of getServices()" [value]="service">
                                                {{service}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="flex-basis: 40%;"
                                        *ngIf="service_charge_info.get('service_list.'+i+'.services')?.value.length > 0">
                                        <mat-select formControlName="service_types">
                                            <mat-option
                                                *ngFor="let service_type of getServiceType(service_charge_info.get('service_list.'+i+'.services')?.value)"
                                                [value]="service_type">
                                                {{service_type}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <button (click)="deleteService(i)" mat-raised-button color="warn">Delete</button>
                                </div>
                            </div>
                        </div>

                    </form>
                    <button (click)="addService()" mat-raised-button color="primary">Add</button>
                </mat-card-content>
                <button mat-button (click)="serviceChargeDialog.close()">Close</button>
            </mat-card>
        </dialog>

        <dialog #claimsDialogBox style="width: 50vw; height: auto;">
            <mat-card
                [ngClass]="{'section': true, 'section-dark': dark_mode.checked, 'section-light': !dark_mode.checked}"
                id="financial-light">
                <mat-card-header>
                    <mat-card-title>Add Claim</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div [formGroup]="claim_info"
                        style="display: flex; justify-content: space-around; margin-top: 20px;">
                        <span style="flex-basis: 40%; display: flex; flex-wrap: wrap;">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Customer Bill To:</mat-label>
                                <input matInput formControlName="customer_name" placeholder="Customer Bill To">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>FBI Reference No:</mat-label>
                                <input matInput formControlName="fbi_reference" placeholder="FBI Reference No">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Date FBI Notified to Customer:</mat-label>
                                <input matInput formControlName="date_notified" [matDatepicker]="claimPicker1">
                                <mat-datepicker-toggle matIconSuffix [for]="claimPicker1"></mat-datepicker-toggle>
                                <mat-datepicker #claimPicker1></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Date Sent To Carrier:</mat-label>
                                <input matInput formControlName="date_sent_to_carrier" [matDatepicker]="claimPicker2">
                                <mat-datepicker-toggle matIconSuffix [for]="claimPicker2"></mat-datepicker-toggle>
                                <mat-datepicker #claimPicker2></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Date Sent By Customer:</mat-label>
                                <input matInput formControlName="date_sent" [matDatepicker]="claimPicker3">
                                <mat-datepicker-toggle matIconSuffix [for]="claimPicker3"></mat-datepicker-toggle>
                                <mat-datepicker #claimPicker3></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Type Of Claims:</mat-label>
                                <input matInput formControlName="claim_type" placeholder="Type Of Claims">
                            </mat-form-field>
                            <span style="width: 100%; display: flex; flex-wrap: nowrap;">
                                <mat-form-field>
                                    <mat-label>Claim:</mat-label>
                                    <input matInput formControlName="claim" placeholder="Claim">
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Currency:</mat-label>
                                    <mat-select formControlName="claim_currency" value="{{getCurrency()[0]}}">
                                        <mat-option *ngFor="let type of getCurrency() | keyvalue" [value]="type.value">
                                            {{type.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </span>
                        </span>
                        <span style="flex-basis: 40%; display: flex; flex-wrap: wrap;">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Amount Paid By Carrier:</mat-label>
                                <input matInput formControlName="amount_paid_carrier"
                                    placeholder="Amount Paid By Carrier:">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Date Paid By Carrier:</mat-label>
                                <input matInput formControlName="date_paid_carrier" [matDatepicker]="claimPicker4">
                                <mat-datepicker-toggle matIconSuffix [for]="claimPicker4"></mat-datepicker-toggle>
                                <mat-datepicker #claimPicker4></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Amount Paid By FBI Group:</mat-label>
                                <input matInput formControlName="amount_paid_fbi"
                                    placeholder="Amount Paid By FBI Group">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Date Paid By FBI Group:</mat-label>
                                <input matInput formControlName="date_paid_fbi" [matDatepicker]="claimPicker5">
                                <mat-datepicker-toggle matIconSuffix [for]="claimPicker5"></mat-datepicker-toggle>
                                <mat-datepicker #claimPicker5></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Payment Method:</mat-label>
                                <input matInput formControlName="payment_method" placeholder="Payment Method">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Reason For Declination:</mat-label>
                                <input matInput formControlName="reason_for_declination"
                                    placeholder="Reason For Declination">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Load Damage Status:</mat-label>
                                <input matInput formControlName="load_damage_status" placeholder="Load Damage Status">
                            </mat-form-field>
                            <mat-form-field style="width: 100%;">
                                <mat-label>Damaged Units:</mat-label>
                                <input matInput formControlName="damaged_unit" placeholder="Damaged Units">
                            </mat-form-field>
                        </span>
                        <input type="text" hidden="true" formControlName="load_damage_uuid">
                    </div>
                    <div style="display: flex; justify-content: flex-end; margin: 28px;">
                        <button style="font-size: 20px;" (click)="claimsDialogBox.close()">Close</button>
                        <button style="font-size: 20px;" (click)="claimsDialogBox.close()">Save</button>
                    </div>
                </mat-card-content>
            </mat-card>
        </dialog>
        <dialog #addToConsol style="background-color: white;position:absolute;left:0%;top:20%;transform: translate(-50%, -50%);" [formGroup]="lading_form">
            <div>Add an order to consolidation</div>
            <mat-form-field style="width: 100%;">
                <mat-label>Alternate Reference Number</mat-label>
                <input matInput formControlName="lading" placeholder="Start typing..." [matAutocomplete]="ladingAuto">
                <mat-autocomplete #ladingAuto="matAutocomplete">
                  <mat-option *ngFor="let item of lading_list | async" [value]="item.label" (click)="selectLading(item)">
                    <span>{{item.label}}</span>
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button mat-button (click)="addToConsol.close(); resetLadingForm()">Close</button>
            <button mat-button (click)="addLadingToConsol(); addToConsol.close()">Save</button>
        </dialog>
        <dialog #removeFromConsol style="background-color: white;position:absolute;left:0%;top:20%;transform: translate(-50%, -50%);" [formGroup]="lading_form">
            <div>Remove an order from consolidation</div>
            <mat-form-field>
                <mat-label>Alternate Reference Number</mat-label>
                <mat-select formControlName="lading" >
                    <ng-container  *ngFor="let lading of associated_ladings">
                        <mat-option *ngIf="lading.uuid != parent_lading_uuid" [value]="lading.alternate_reference" (click)="selectLadingToRemove(lading)">{{lading.alternate_reference}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <button mat-button (click)="removeFromConsol.close(); resetLadingForm()">Close</button>
            <button mat-button (click)="removeFromConsol.close(); removeLadingFromConsol()">Remove</button>
        </dialog>
    </div>
</div>